import { images } from "../assets/img";

export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/PzxQ7zsSunavUUTn6",
  address: "12 Birmingham Rd, Great Barr, Birmingham B43 6NR",
  ggMapIframeUrl:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2426.2589772783963!2d-1.9372796870040394!3d52.54684023412462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4870a31d428dd8a1%3A0xebb90565374d9a7a!2s12%20Birmingham%20Rd%2C%20Great%20Barr%2C%20Birmingham%20B43%206NR%2C%20UK!5e0!3m2!1sen!2s!4v1754666300488!5m2!1sen!2s",
  email: "happynailgreatbarr@gmail.com",
  tel: "+447404410009",
  phone: "+44 740 441 0009",
  facebookId:"761404163721508",
  instagramName: "happy_nails_greatbarr",
  name: "Happy Nails Great Barr",
  openingTime:{
    openTime:{weekdays: "MONDAY - SATURDAY", time:"09:30 - 18:30"},
    closeTime:{weekdays: "SUNDAY & BANK HOLIDAY", time:"CLOSED"}
  }
};

NAIL_SHOP_INFO.instagram = `https://www.instagram.com/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.instagramChatUrl = `https://ig.me/m/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.facebook = `https://www.facebook.com/profile.php?id=${NAIL_SHOP_INFO.facebookId}`
NAIL_SHOP_INFO.facebookMessengerUrl = `http://m.me/${NAIL_SHOP_INFO.facebookId}`

export const SOLCO_INFO = {
  facebook: "https://www.facebook.com/solcoagency.marketing",
  website: "https://solcomarketing.com",

  huaCatLuongWebsite: "https://huacatluong.com",
};

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};

export const CUSTOMER_FEEDBACK = [
  {
    name: "Holly James",
    feedback:
      "Ã¢â‚¬Å“The calm and relaxing atmosphere at Happy Nails Great Barr keeps me coming back. Their nail care tips are also so useful.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/kI3rsKc.jpg",
  },
  {
    name: "Zara Mitchell",
    feedback:
      "Ã¢â‚¬Å“Lovely salon, IÃ¢â‚¬â„¢ve had both a pedicure and manicure here and was very happy with both. Friendly people and good prices. IÃ¢â‚¬â„¢ll be back Ã°Å¸â€˜Å’Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/aCEUi1W.png",
  },
 
  {
    name: "Lily Morgan",
    feedback:
      "Ã¢â‚¬Å“Took my mom here for her birthday and it was perfect. The staff made us feel so special with every little detail.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/92gXkP8.jpg",
  },
  {
    name: "Chloe Bennett",
    feedback:
      "Ã¢â‚¬Å“Lovely salon, so many colors to choose from and such friendly staffÃ¢â‚¬Â¦ and most importantly, amazing nails! New shop but clearly very experienced team.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/g7mJPq8.png",
  },
  {
    name: "Maya Thompson",
    feedback:
      "Ã¢â‚¬Å“Thank you Hanna! So friendly and professionalÃ¢â‚¬Â¦ I love my acrylic French tips on hands and toes. Clean, fresh salon with great massage chairs Ã¢ÂÂ¤Ã¯Â¸ÂÃ¢ÂÂ¤Ã¯Â¸Â Highly recommend!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/0JaNnhK.png",
  },
  {
    name: "Amelia Foster",
    feedback:
      "Ã¢â‚¬Å“Visited Happy Nails Great Barr today. Very welcoming. My nails look perfect and IÃ¢â‚¬â„¢ll definitely return. Great prices too. Very happy!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/VxekuRS.png",
  },
  {
    name: "Grace Taylor",
    feedback:
      "Ã¢â‚¬Å“Booked a last-minute gel manicure at Happy Nails Great Barr and was so impressed. Weeks later, itÃ¢â‚¬â„¢s still flawless!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/KxhUFKM.jpg",
  },
   {
    name: "Sophie Carter",
    feedback:
      "Ã¢â‚¬Å“Walked in and was seen straight away. The staff were so nice! Had BIAB done and itÃ¢â‚¬â„¢s the best IÃ¢â‚¬â„¢ve had in Edinburgh. Lovely space and great results!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/F7M14q2.png",
  },
]


export const MENU_HEADER = [
  { name: "Home", navigationKey: "home" },
  { name: "About Us", navigationKey: "about-us" },
  { name: "Services", navigationKey: "services" },
  { name: "Call to Book", navigationKey: `tel:${NAIL_SHOP_INFO.tel}` },
  // { name: "Contacts", navigationKey: "contactsRef" },
  { name: "Contact", navigationKey: "contact-us" },
  { name: "Policy", navigationKey: "policy" },
];
